// extracted by mini-css-extract-plugin
export default {"BookCloudPlusFooter":"BookCloudPlusFooter_BookCloudPlusFooter__mWDa1","bookcloud_register_btn":"BookCloudPlusFooter_bookcloud_register_btn__AykPp"};